// SPDX-License-Identifier: MIT
import { t } from '../i18n/t';

export interface FooterOptions {
  onSignOut?: () => void;
}

export function renderFooter(opts: FooterOptions = {}): HTMLElement {
  const el = document.createElement('footer');
  el.className = 'site-footer';
  const signOutLink = opts.onSignOut
    ? `<a data-component="footer-signout" href="#" class="site-footer__signout">${t('footer.signOut')}</a>`
    : '';
  el.innerHTML = `
    <span>${t('footer.copyright')}</span>
    <div class="site-footer__links">
      <a data-component="footer-link" href="#contact">${t('footer.contact')}</a>
      <a data-component="footer-link" href="https://github.com/myconciergerie-prog/project-genesis" target="_blank" rel="noopener noreferrer">${t('footer.github')}</a>
      <a data-component="footer-link" href="https://github.com/myconciergerie-prog/project-genesis#readme" target="_blank" rel="noopener noreferrer">${t('footer.roadmap')}</a>
      <a data-component="footer-tarifs" data-nav href="/tarifs">${t('footer.tarifs')}</a>
      <a data-component="footer-link" href="#privacy">${t('footer.privacy')}</a>
      ${signOutLink}
    </div>
  `;
  if (opts.onSignOut) {
    el.querySelector<HTMLAnchorElement>('[data-component="footer-signout"]')?.addEventListener('click', (e) => {
      e.preventDefault();
      opts.onSignOut!();
    });
  }
  return el;
}
